import React, { useEffect, useState } from "react";
import { Button, Col, Row, Form } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import { SapInvoiceOldTable } from "./SapInvoiceOldTable";
import { useSelector, useDispatch } from "react-redux";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchAll,
} from "./invoiceOldSlice";

export const SapInvoiceOldPage = () => {
  const dispatch = useDispatch();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);

  // Filter
  const [date, setDate] = useState("");
  const [clientCode, setClientCode] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [plantName, setPlantName] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [taxInvoice, setTaxInvoice] = useState("");

  useEffect(() => {
    // Reset on first load
    dispatch(resetData());
  }, [dispatch]);

  const handleSearch = () => {
    const params = {
      date: date,
      clientCode: clientCode,
      invoiceNo: invoiceNo,
      plantName: plantName,
      customerName: customerName,
      taxInvoice: taxInvoice,
      pageNo: pageNo,
      pageSize: pageSize,
    };
    console.log("params", params);
    dispatch(fetchAll(params));
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    const params = {
      clientCode: clientCode,
      invoiceNo: invoiceNo,
      plantName: plantName,
      customerName: customerName,
      taxInvoice: taxInvoice,
      pageNo: page,
      pageSize: sizePerPage,
    };
    console.log("params", params);
    dispatch(fetchAll(params));
  };
  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="SAP Invoice Old"></CardHeader>
      <CardBody>
        {/* Filter */}
        <Form>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Transaction Date</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="date"
                    placeholder="Transaction Date"
                    onChange={(e) => {
                      setDate(e.target.value);
                    }}
                    value={date}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Client Code</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Client Code"
                    onChange={(e) => {
                      setClientCode(e.target.value);
                    }}
                    value={clientCode}
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Invoice Ref Number</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="number"
                    placeholder="Invoice  Ref Number"
                    onChange={(e) => {
                      setInvoiceNo(e.target.value);
                    }}
                    value={invoiceNo}
                  />
                </Col>
              </Form.Group>
            </Col>
            {/* Row kiri */}
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Plant Name</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Plant Name"
                    onChange={(e) => {
                      setPlantName(e.target.value);
                    }}
                    value={plantName}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Customer Name</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Customer Name"
                    onChange={(e) => {
                      setCustomerName(e.target.value);
                    }}
                    value={customerName}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Tax Invoice Number</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="number"
                    placeholder="Tax Invoice Number"
                    onChange={(e) => {
                      setTaxInvoice(e.target.value);
                    }}
                    value={taxInvoice}
                  />
                </Col>
              </Form.Group>
            </Col>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Button className="btn btn-primary" onClick={handleSearch}>
                  Search
                </Button>
              </Col>
            </Form.Group>
          </Form.Group>
        </Form>

        {/* Table */}
        {data.length > 0 && (
          <SapInvoiceOldTable
            data={data}
            page={pageNo}
            sizePerPage={pageSize}
            totalSize={totalRecord}
            onTableChange={handleTableChange}
            loading={loading}
          />
        )}
      </CardBody>
    </Card>
  );
};
